<template>
    <cmpcosafacciamo @sigpageresized="fnSetTimerResized()" ></cmpcosafacciamo>
    <cmpfooter :sticktobottom="sticktobottom"></cmpfooter>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import cmpcosafacciamo from "./cmpcosafacciamo.vue"
import cmpfooter from "../components/cmpfooter.vue"






export default {
  name: "cosafacciamo",
  mixins:[multilangmixin],
  components:{
    cmpcosafacciamo,
    cmpfooter
    
  },
  props:{
    
     "lang":String,
  },


  data(){
     return {
          "sticktobottom":false
    } 
  },

  created(){
      this.fnOnSigPageResized();
  },

  
  methods:{

      fnSetTimerResized()
      {
        window.setTimeout(this.fnOnSigPageResized,300);
      },

      fnOnSigPageResized()
      {
          if (document.body.scrollHeight>window.innerHeight)
          {
            this.sticktobottom=false;
          }
          else
          {
            this.sticktobottom=true;
            
          }
        

          //console.log(this.sticktobottom,document.body.scrollHeight,window.innerHeight);
      }

  }



}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
